import { render, staticRenderFns } from "./Ordenacao.vue?vue&type=template&id=313ea782&scoped=true&lang=pug"
import script from "./Ordenacao.vue?vue&type=script&lang=js"
export * from "./Ordenacao.vue?vue&type=script&lang=js"
import style0 from "./Ordenacao.vue?vue&type=style&index=0&id=313ea782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313ea782",
  null
  
)

export default component.exports